export type AgentLanguageKey =
  | 'JAVA'
  | 'DOTNET'
  | 'DOTNET_CORE'
  | 'NODE'
  | 'RUBY'
  | 'PYTHON'
  | 'PHP'
  | 'PROXY'
  | 'GO'

export type AgentLanguageValue =
  | 'Java'
  | '.NET'
  | '.NET Core'
  | 'Node'
  | 'Ruby'
  | 'Python'
  | 'PHP'
  | 'Proxy'
  | 'Go'

export type AgentLanguageDisplay =
  | 'Java'
  | '.NET Framework'
  | '.NET Core'
  | 'Node'
  | 'Ruby'
  | 'Python'
  | 'PHP'
  | 'Proxy'
  | 'Go'

export class AgentLanguage {
  public static readonly JAVA = new AgentLanguage('JAVA', 'Java', 'Java')
  public static readonly DOTNET = new AgentLanguage(
    'DOTNET',
    '.NET',
    '.NET Framework'
  )
  public static readonly DOTNET_CORE = new AgentLanguage(
    'DOTNET_CORE',
    '.NET Core',
    '.NET Core'
  )
  public static readonly NODE = new AgentLanguage('NODE', 'Node', 'Node')
  public static readonly RUBY = new AgentLanguage('RUBY', 'Ruby', 'Ruby')
  public static readonly PYTHON = new AgentLanguage(
    'PYTHON',
    'Python',
    'Python'
  )
  public static readonly PHP = new AgentLanguage('PHP', 'PHP', 'PHP')
  public static readonly PROXY = new AgentLanguage('PROXY', 'Proxy', 'Proxy')
  public static readonly GO = new AgentLanguage('GO', 'Go', 'Go')

  public static getAllAsArray = () => {
    return [
      AgentLanguage.JAVA,
      AgentLanguage.DOTNET,
      AgentLanguage.DOTNET_CORE,
      AgentLanguage.NODE,
      AgentLanguage.RUBY,
      AgentLanguage.PYTHON,
      AgentLanguage.PHP,
      AgentLanguage.PROXY,
      AgentLanguage.GO
    ]
  }

  public static fromValue = (value: string) => {
    switch (value) {
      case 'Java':
        return AgentLanguage.JAVA
      case '.NET':
        return AgentLanguage.DOTNET
      case '.NET Core':
        return AgentLanguage.DOTNET_CORE
      case 'Node':
        return AgentLanguage.NODE
      case 'Ruby':
        return AgentLanguage.RUBY
      case 'Python':
        return AgentLanguage.PYTHON
      case 'PHP':
        return AgentLanguage.PHP
      case 'Proxy':
        return AgentLanguage.PROXY
      case 'Go':
        return AgentLanguage.GO
      default:
        throw new Error(`Unexpected agent language value: ${value}`)
    }
  }

  public static fromKey = (key: string) => {
    switch (key) {
      case 'JAVA':
        return AgentLanguage.JAVA
      case 'DOTNET':
        return AgentLanguage.DOTNET
      case 'DOTNET_CORE':
        return AgentLanguage.DOTNET_CORE
      case 'NODE':
        return AgentLanguage.NODE
      case 'RUBY':
        return AgentLanguage.RUBY
      case 'PYTHON':
        return AgentLanguage.PYTHON
      case 'PHP':
        return AgentLanguage.PHP
      case 'PROXY':
        return AgentLanguage.PROXY
      case 'GO':
        return AgentLanguage.GO
      default:
        throw new Error(`Unexpected agent language key: ${key}`)
    }
  }

  private constructor(
    private key: AgentLanguageKey,
    private value: AgentLanguageValue,
    private display: AgentLanguageDisplay
  ) {}

  public toString = () => `AgentLanguage.${this.key}`
  public getName = () => this.key
  public getValue = () => this.value
  public getDisplay = () => this.display

  public isDotNetFlavor = () =>
    this.key === 'DOTNET' || this.key === 'DOTNET_CORE'
}
